import type { RouteRecordRaw } from 'vue-router';

/**
 * Import & export screens (ADR-027/ADR-031): a single nav entry ("Import & export") hosting an
 * import wizard + export history, plus a detail route for one import batch's dry-run/commit flow.
 * Kept in its own file so `router.ts` only needs one additive spread line (parallel-work rule).
 * No `meta.requiresModule`: imports/reporting are permission-gated platform capabilities, not
 * entitlement-gated business modules (neither has a `ModuleManifest`), so the page itself renders a
 * `ForbiddenState` when the caller has neither `imports.targets.read` nor `reporting.exports.read`.
 */
export const dataExchangeRoutes: RouteRecordRaw[] = [
  {
    path: 'data-exchange',
    name: 'data-exchange',
    component: () => import('../pages/data-exchange/DataExchangePage.vue'),
  },
  {
    path: 'data-exchange/imports/:batchId',
    name: 'data-exchange-import-batch',
    component: () => import('../pages/data-exchange/ImportBatchPage.vue'),
    props: true,
  },
];
